import PropTypes from 'prop-types';

function IFSnacksInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M4.36299 12.8444L21.9738 7.16281C21.513 2.20682 4.33397 9.9238 3.86231 11.3388C3.79684 11.8816 3.86023 12.4322 4.04735 12.946L4.36299 12.8444Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.08127 10.3956C4.53343 8.17161 6.09351 5.63557 9.48941 8.29497C12.8853 10.9544 9.96107 13.5086 9.96107 13.5086L6.73568 13.4251C6.73568 13.4251 5.28444 11.2337 5.08127 10.3956Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M6.79739 8.83936C5.28447 7.13415 4.95431 4.33326 9.24636 4.60536C13.5384 4.87747 13.9919 9.74639 13.9919 9.74639L10.3312 11.7418C10.3312 11.7418 7.55929 9.69196 6.79739 8.83936Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.6196 9.88042C12.8056 8.48723 12.4428 5.20742 15.9983 3.34983C19.8078 1.35438 19.9892 7.80514 19.9892 7.80514L18.0301 10.3448L14.6196 9.88042Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M12.6641 10.432C11.4124 8.51269 11.1512 4.6669 15.4432 4.939C19.7352 5.21111 18.4364 10.2433 18.4364 10.2433L15.7443 11.9993L12.6641 10.432Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M7.84595 13.1129C7.30173 10.8852 8.33211 7.17007 12.2904 8.84988C16.2486 10.5297 13.3534 14.8508 13.3534 14.8508L10.2296 15.6127L7.84595 13.1129Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M14.9244 12.4494C13.6727 10.5301 14.402 7.312 18.3929 6.73151C22.6486 6.11836 20.6967 12.2607 20.6967 12.2607L18.0047 14.0167L14.9244 12.4494Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M4.0473 12.9463C4.77339 15.0846 6.06319 16.9874 7.78062 18.4537C11.1148 21.3562 9.7398 27.9231 11.7715 28.8555C13.8033 29.7879 30.6086 26.5916 27.8005 20.5508C25.5583 15.7182 22.4091 12.1227 21.9738 7.16309L4.0473 12.9463Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M4.0473 12.9463L21.9738 7.16309C22.0393 7.77281 22.1386 8.37842 22.2713 8.97714L4.59877 14.3286L4.0473 12.9463Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.495 15.3554C12.5626 16.8683 10.549 20.9934 15.0442 22.8075C19.5394 24.6215 21.709 20.9572 21.9376 19.4152C22.1807 17.5794 21.7163 15.3445 20.1236 14.4302C18.5308 13.5159 14.8338 13.1821 13.495 15.3554Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.2091 22.7529L12.4173 27.6545L18.781 25.913C18.781 25.913 14.8481 25.5502 13.7488 25.1475C13.4077 25.0169 11.2091 22.7529 11.2091 22.7529Z"
                fill="#F8F2ED"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.6376 18.345C14.7211 17.9169 15.3306 15.5332 17.3261 15.9432C19.3215 16.3532 19.9456 17.1949 20.3301 17.9967"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.4528 20.1589C14.7793 20.6233 17.758 23.1412 20.0981 20.0029"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default IFSnacksInactive;

IFSnacksInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

IFSnacksInactive.defaultProps = {
    className: null,
};
